/**
 * Popups Util
 *
 * A utility class to make it easier to create popups from anywhere on the website
 */
define([
    'jquery'
], function($) {
    'use strict';

    return {

        /**
         * Display the popup
         *
         * @param {string|false} title             A string for the title, or false if the popup has no title
         * @param {string}       content           The content to be put into the popup
         * @param {string}       additionalClasses [Optional] Any special classes that should be added to the outer-most
         *                                         container of the popup, used for specific styling of certain popups
         *
         * @returns null
         */
        displayPopUp: function(title, content, additionalClasses) {
            var PopupsUtil = this;
            var $popupNode = PopupsUtil.injectPopupNode(title !== false, additionalClasses);
            var $popupNodeTitle = $popupNode.find(".popups-util__title");
            var $popupContent = $('.popup-util__contents');

            if (title !== false) {
                $popupNodeTitle.html(title);
            }

            $popupContent.html(content);

            $("body").toggleClass("noScroll", true);

            PopupsUtil.attachClickHandlers($popupNode);
            return $popupNode;
        },

        /**
         * Inject a new DOM node for the popup
         *
         * Returns the node created as a jQuery object
         *
         * @param {boolean} includeTitle      Flag to indicate if the title container is required
         * @param {string}  additionalClasses Additional classes to be added to the popup container element
         *
         * @returns {jQuery}
         */
        injectPopupNode: function(includeTitle, additionalClasses) {
            var PopupsUtil = this;
            var popupTemplate = PopupsUtil.getPopupTemplate(includeTitle, additionalClasses);
            $('body').append(popupTemplate);
            return $(".popups-util__content");
        },

        /**
         * Attach click handlers to the various parts of the popup modal
         *
         * @param {jQuery} $popupNode The jQuery object of the popup that the handlers are being attached to
         *
         * @returns null
         */
        attachClickHandlers: function($popupNode) {
            var PopupsUtil = this;
            var $popupOverlay = $(".popups-util__overlay");

            $popupOverlay.on('mousedown', function(e) {PopupsUtil.handleClickOverlay(e, $popupNode)});
        },

        /**
         * Handle the event fired when an element in the popup_overlay is clicked.
         * Seeing as though the popup content is nested inside the popup overlay, this would mean that anything
         * in the actual popup was clicked too
         *
         * @param {Object} e          The event object
         * @param {jQuery} $popupNode The popup jQuery object
         *
         * @returns null
         */
        handleClickOverlay: function(e, $popupNode) {
            var PopupsUtil = this;
            var $target = $(e.target);

            if ($target.hasClass("popup-close-button") //Self explanatory
                || $target.closest(".popups-util__content").length === 0 //Check if the clicked element has the popup content parent. If not, then it was the overlay background that was clicked
            ) {
                PopupsUtil.closeAndDestroyPopup($popupNode);
            }
        },

        /**
         * Close the popup and remove it from the DOM
         *
         * @returns null
         */
        closeAndDestroyPopup: function($popupNode) {
            $popupNode.trigger('close');
            $popupNode.remove();
            $(".popups-util__overlay").remove();
            $("body").toggleClass("noScroll", false);
        },

        /**
         * Get the HTML structure of the popup
         *
         * @param {boolean} includeTitle      Flag to indicate if the title container is required
         * @param {string}  additionalClasses Additional classes that should be added to the popup container element
         *
         * @returns {string}
         */
        getPopupTemplate: function(includeTitle, additionalClasses) {
            var extraClasses = "";
            var extraContainer = "";
            if (typeof additionalClasses !== 'undefined') {
                extraClasses = " " + additionalClasses;
                extraContainer = " " + additionalClasses + "__container";
            }
            var template = '<div class="popups-util__overlay popup_overlay' + extraContainer + '">'+
                    '<div class="popups-util__content popup_content' + extraClasses + '">' +
                    '<div class="popups-util__header popup_header">'+
                     '<div class="popup-close"><button class="popup-close-button"></button></div>';
            if (includeTitle) {
                template += '<div class="popups-util__title popup_title"></div>';
            }
            template += '</div><!-- /.popups-util__header -->'+
                    '<div class="popup-util__contents popup-contents"></div>' +
                   '</div><!-- /.popups-util__content -->'+
                '<!-- /.popups-util__overlay here --></div>';

            return template;
        }
    };
});
